module.exports = "<xml id=\"toolbox\">\n  <block type=\"use\">\n    <value name=\"POSITION\">\n      <block type=\"nearestVoxel\"></block>\n    </value>\n  </block>\n  <block type=\"jump\"></block>\n  <block type=\"controls_forever\"></block>\n</xml>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src/blockly/toolbox.xml
 ** module id = 780
 ** module chunks = 0
 **/